<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Afregning mod G4 gået i stå</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content class="align-center">
  @if (serviceorderNo) {
    <p class="form-headline align-center">Serviceordre nummer: {{ serviceorderNo }}</p>
  }
  @if (agreementNo) {
    <p class="form-headline align-center">Aftale nummer: {{ agreementNo }}</p>
  }
  @if (amountExclVat) {
    <p class="form-headline align-center">Beløb ekskl. moms: {{ amountExclVat | dkCurrency }}</p>
  }
  @if (amountInclVat) {
    <p class="form-headline align-center">Beløb inkl. moms: {{ amountInclVat | dkCurrency }}</p>
  }

  <p class="orange med-text align-center">
    <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
    <br />
    <span>Afregning fejlet mod G4!</span>
    <br />
    <span>
      <em>{{ errorTextG4 }}</em>
    </span>
  </p>
  <p>Hvad skal der ske med afregningen?</p>

  <form [formGroup]="form" [attr.autocomplete]="'off'">
    @if (isCreditnote) {
      <div class="form-row">
        <mat-checkbox formControlName="accept">
          Dette er en kreditnota som også kan være bogført manuelt i G4.
          <br />
          Jeg er opmærksom på at indsættelse af ukorrekt G4 bilagsnummer i EGIS kan medføre difference mellem EGIS og G4 på denne aftale
        </mat-checkbox>
      </div>
    }
    @if (accept.value) {
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>G4 bilagsnummer til kreditnota</mat-label>
          <input formControlName="returnBilagsnr" matInput />
          <mat-hint align="end">
            <app-character-count [control]="returnBilagsnr" [maxlength]="10"></app-character-count>
          </mat-hint>
          @if (returnBilagsnr.hasError('maxlength')) {
            <mat-error>G4 bilagsnummer må højest være 10 karakterer lang.</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Købsdato</mat-label>
          <input #input matInput [matDatepicker]="picker" formControlName="returnOpkraevningDate" [min]="minDate" [max]="maxDate" />
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          @if (returnOpkraevningDate.hasError('required')) {
            <mat-error>Købsdato er påkrævet.</mat-error>
          }
        </mat-form-field>
      </div>
    }
  </form>
</div>
<div mat-dialog-actions class="align-center">
  @if (!accept.value) {
    <button mat-raised-button (click)="retry()" matTooltip="Afregning mod G4 forsøges igen">
      Forsøg afregning igen
    </button>
  }
  @if (!accept.value) {
    <button mat-raised-button (click)="cancel()" matTooltip="Afregningen annulleres">Fortryd afregning</button>
  }
  @if (isCreditnote && accept.value) {
    <button
      mat-raised-button
      (click)="finish_up()"
      [disabled]="$safeNavigationMigration(form?.invalid)"
      matTooltip="Afregningen færdiggøres efter manuel afregning i G4"
      >
      Færdiggør afregning
    </button>
  }
</div>
